import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'

import { AppState } from '../../../store/rootReducer'
import { analytinsAnonce } from '../../Analytics/Analytics'
import CollectionVideo from '../CollectionVideo/CollectionVideo'
import { NewAnonceCardProps } from './NewAnonceCard.types'

export const NewAnonceCard = (props: NewAnonceCardProps) => {
  const { image, video, title, category, description, id, currentPage } = props
  const pageName = useSelector((state: AppState) => state.page.name)

  const clickHandler = () => {
    analytinsAnonce(
      pageName,
      title ? title : description,
      category,
      id,
      currentPage
    )
  }

  return (
    <Link
      className='new-anonce-card'
      to={`${category}${id}`}
      onClick={clickHandler}
    >
      {image ? (
        <img src={image} alt='Обложка подборки ' />
      ) : (
        video && <CollectionVideo props={video} />
      )}
      <div className='new-anonce-card__content'>
        {title && <h3>{title}</h3>}
        <span>{description}</span>
        <div className='new-anonce-card__btn'>
          <div className='btn btn--small btn--white no-hover'>
            {category.indexOf('collection') !== -1 ? 'Смотреть' : 'Читать'}
          </div>
        </div>
      </div>
    </Link>
  )
}
